<template>
<div>
    <div class="mb-4" v-if="user.role.master">
        <v-btn depressed class="accent" @click="$router.push('/admin-sessions/set')">Update materials</v-btn>
        <div class="caption mt-1 grey--text text--darken-2 ml-1 d-flex align-center">
            <v-icon size="12px" class="mr-2" color="amber darken-2">fa-exclamation-triangle</v-icon>
            <div>Visible only for Master</div>
        </div>
    </div>

    <div v-for="(item, index) in items" :key="item.id">
        <v-row>
            <v-col cols="12" md="10">
                <div>
                    <div class="subtitle-1 primary--text font-weight-medium d-flex align-center">
                        <!-- <v-icon small color="primary" class="mr-2">fa-angle-right</v-icon> -->
                        SESSION {{index+1}}
                    </div> 
                    <div class="body-2">
                        <ul>
                            <li v-for="it in item.tips" :key="it.id" v-html="it"></li>
                        </ul>
                    </div>

                    <div class="ml-4 mt-3" v-if="item.materials">
                        <div v-for="it in item.materials" :key="it.id">
                            <v-btn text class="accent--text" target="_blank" :href="it.url">
                                <v-icon left small color="accent">fa-cloud-download-alt</v-icon>
                                <span>{{it.title}}</span>
                            </v-btn>
                        </div>
                    </div>
                </div>
            </v-col>
        </v-row>

        <v-row v-if="index<items.length-1">
            <v-col col="12">
                <v-divider></v-divider>
            </v-col>
        </v-row>
    </div>
</div>
</template>

<script>
import _ from 'lodash'
import Helpers from '@/services/helpers'
import Sessions from '@/firebase/sessions'

export default {
    data: () => ({
        loaded: false,
        items: []
    }),
    mounted() {
        this.init();
    },
    methods: {
        init() {
            Sessions.getAll()
                    .then(response => {
                        if (response.status === true) {
                            this.items = Helpers.formatItems(response.query);
                            this.items.forEach(dt => {
                                dt.fac = Number(dt.id.substr(1, dt.id.length));
                                // dt.tips.forEach(d => {
                                //     d = JSON.stringify(d);
                                //     d = d.replace(/\n/g, "<br />");
                                //     console.log(d)
                                // });
                            });
                            this.items = _.sortBy(this.items, 'fac', 'asc');
                            this.loaded = true;
                        } else {
                            this.$store.dispatch('setSnack', {kind:'error', text:'An error ocurred. Please try later.'});
                        }
                    });
        }
    }
}
</script>